import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 10,
    seconds: 0
  });
  useEffect(() => {
    // Get end time from local storage or set it for 10 minutes from now
    const storedEndTime = localStorage.getItem('offerEndTime');
    let endTime: number;
    if (storedEndTime && new Date(storedEndTime).getTime() > Date.now()) {
      endTime = new Date(storedEndTime).getTime();
    } else {
      endTime = Date.now() + 10 * 60 * 1000; // 10 minutes
      localStorage.setItem('offerEndTime', new Date(endTime).toISOString());
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        // Reset timer if expired
        const newEndTime = Date.now() + 10 * 60 * 1000;
        localStorage.setItem('offerEndTime', new Date(newEndTime).toISOString());
        endTime = newEndTime;
        return;
      }
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="w-full bg-red-600 text-white py-3 px-4 flex justify-center items-center gap-3 shadow-lg" data-id="element-239">
      <Timer className="w-6 h-6 animate-pulse" data-id="element-240" />
      <div className="text-lg font-bold font-mono tracking-wider" data-id="element-241">
        OFERTA TERMINA EN: {String(timeLeft.hours).padStart(2, '0')}:
        {String(timeLeft.minutes).padStart(2, '0')}:
        {String(timeLeft.seconds).padStart(2, '0')}
      </div>
    </div>;
}